import {Card,
  Typography,
  TextField,
  Button,
  Box,
  Container,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';

import {  toast } from 'react-toastify';
import 'assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import { useMaterialUIController, setOrderContext } from "context";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";


import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Config from "config.js";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { handleErrors } from "common.js";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function Pickup() {

  const [controller, dispatch]           = useMaterialUIController();
  const { orderContext, paginationSize } = controller;
  
  const [packageCount, setPackageCount] = useState(0);
  const [pickupDateHelperText, setPickupDateHelperText] = useState('');
 

  const navigate   = useNavigate();
  const { pageNo } = useParams();

  var pageSelected     = 1;

  if(typeof pageNo !== "undefined")
  {
      const parts  = pageNo.split("-");
      pageSelected = parts[1].trim(); 
  }
    
  const { t } = useTranslation();

  const baseUrl     = Config.baseUrl;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState({});
  const [resultCount, setResultCount] = useState(0);
  const [pickupModelOpen, setPickupModelOpen] = useState(false);
  const [pickupDate, setPickupDate] = useState(null);
  const [minTime, setMinTime] = useState(new Date());
  const [maxTime, setMaxTime] = useState(new Date().setHours(23, 59, 59));
  const [highlightedDates, setHighlightedDates] = useState([]);
  const [disabledDates, setDisabledDates] = useState([]);
  
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 6); 

  useEffect(() => {
    listPickupRequest();
  }, [pageNo]);

  const handleChangePackageCount = (event) => {
    setPackageCount(event.target.value);   
  };
    
  const handlePickupModelSubmit = () => {
    
    let requestPayLoad;
  
    if(pickupDate === '' || pickupDate === null)
    {
        setPickupDateHelperText(t("pickupDateEmpty"));
        return;
    }
    
    requestPayLoad = {
      pickupDate   : pickupDate,
      packageCount : parseInt(packageCount),
    };
   
    setIsLoading(true);
  
    axios({      
          url     : baseUrl+"/order/save-pickup-request",
          method  : "POST",
          data    : requestPayLoad,
          headers : {
            Authorization   : bearerToken,
            function        : Config.FUNCTION_KEY
          },                  
        }).then(function (response) 
        {
            setIsLoading(false);
            manageAPIResponse(response, 0);

        }).catch(function (error) {  
          setIsLoading(false);
          handleErrors(error, t, navigate);         
        });
    };
  
    const listPickupRequest = () => {   
      axios({      
            url     : baseUrl+"/order/get-pickup-request/"+pageSelected,
            method  : "GET",
            headers : {
              Authorization   : bearerToken,
              function        : Config.FUNCTION_KEY
            },        
          }).then(function (response) 
          {      
              manageAPIResponse(response, 1);

          }).catch(function (error) {
            handleErrors(error, t, navigate);
          });
    }

    const manageAPIResponse = (response, initialLoad) => {

        const responseData           = response.data;
        const responseDataStatusCode = response.data.status;
        const responseStatusCode     = response.status;

        if(responseStatusCode === 200)
        {         
            if(responseDataStatusCode === 1)
            {
                if(initialLoad === 0)
                toast.success(t(response.data.message));

                createTableLayout(responseData);
            }
            else
            {
                toast.error(t(response.data.message));
                return;
            }
        }    
        else 
        {
          toast.error(t('An unexpected error occurred while communicating with server'));
          return;            
        }   
    };

    const createTableLayout = (responseData) => {

        const columns  =  [
          { Header: `${t("Pickup ID")}`, accessor: "pickupRequestID", align: "left"},
          { Header: `${t("Pickup Date")}`, accessor: "pickupDate", align: "left" },
          { Header: `${t("Pickup Time")}`, accessor: "pickupTime", align: "left" },
          { Header: `${t("Pickup Center")}`, accessor: "pickupCenterName", align: "left" },
          { Header: `${t("Package Count")}`, accessor: "expectedPackageCount", align: "left"},
        ];
        
        var rows = [];  
        
        if(responseData.data.rows)
        {
            responseData.data.rows.map((item, index) => {
                var tempData = {
                  "pickupRequestID"      : item.pickupRequestID,
                  "pickupDate"           : item.pickupDate,
                  "pickupTime"           : item.pickupTime,
                  "pickupCenterName"     : item.pickupCenterName,
                  "expectedPackageCount" : item.expectedPackageCount,
                };
                
                rows.push(tempData);
            });
        }

        setTableData({ columns, rows });

        if(responseData.data.totalCount)
        setResultCount(responseData.data.totalCount);

        if(responseData.data.highlightedDates)
        setHighlightedDates(responseData.data.highlightedDates);

        if(responseData.data.disabledDates)
        setDisabledDates(responseData.data.disabledDates);        
    };

    const handlePickupModelClose = () => {
      setPickupModelOpen(false);
      setPackageCount(0);
      setPickupDate(null);
      setPickupDateHelperText('');
    };

    const handleChangePickupDate = (date) => {
      setPickupDate(date);
      
      if(date){
        setPickupDateHelperText('');    

        const selectedDate = new Date(date);
        const today        = new Date();

        if(selectedDate.toDateString() === today.toDateString())
        setMinTime(today); 
        else
        setMinTime(selectedDate.setHours(0, 0, 0, 0));
        
        setMaxTime(selectedDate.setHours(23, 59, 59));
      }      
    };

    const handlePickupSubmit = () => {  
      setPickupModelOpen(true);
  }
 
  const pickupModelLoad = () => {

    return (
      
        <Dialog id="pickup-dialog" open={pickupModelOpen} onClose={handlePickupModelClose}>

          <DialogTitle onClose={handlePickupModelClose}>
            {t("New Pickup Request")}  
          </DialogTitle>

          <DialogContent dividers sx={{width: '500px'}}>

            <Grid container spacing={1} my={2}>
              <Grid item sm={6} xs={12}>
                <Typography variant="body2"  sx={{fontSize: 14}}>
                  {t("Pickup Date")}{<span className='custom-required-star'>*</span>}
                </Typography>
                <DatePicker
                        selected={pickupDate}
                        onChange={handleChangePickupDate}
                        showTimeSelect
                        minDate={new Date()}
                        maxDate={maxDate}
                        minTime={minTime}
                        maxTime={maxTime}
                        dateFormat="yyyy-MM-dd hh:mm aa"
                        timeFormat="HH:mm"
                        timeIntervals={240}
                        timeCaption={t("Time")}
                        className="custom-datepicker-input"
                        highlightDates={highlightedDates.map((date) => new Date(date))}
                        filterDate={(date) => {
                          return !disabledDates.includes(date.toISOString().split("T")[0]);
                        }}
                        required
                      />
                <FormHelperText sx={{ position: 'relative', bottom: 0, color: 'red' }}>
                  {pickupDateHelperText}
                </FormHelperText> 
              </Grid>

              <Grid item sm={6} xs={12}>
                <Typography variant="body2" sx={{fontSize: 14}}>
                  {t("Package Count")}
                </Typography>
                <TextField 
                  type = "number"
                  variant = "outlined" 
                  value = {packageCount}
                  inputProps={{
                    min: 0,
                  }}
                  onChange={handleChangePackageCount} 
                  required
                />                      
              </Grid>
            </Grid>
            <Container className="buttonContainer">
                <Box my={2}>
                  <Button                     
                    variant="contained" 
                    sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                    onClick={() => handlePickupModelSubmit()}
                    disableRipple
                    disabled={isLoading}
                    >
                    {t("Submit")}
                  </Button>

                  <Button                     
                    variant="contained" 
                    sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                    onClick={handlePickupModelClose}
                    disableRipple
                    disabled={isLoading}
                    >
                    {t("Cancel")}
                  </Button>
                </Box>
            </Container>
            {isLoading ?       
              <Container sx={{textAlign: 'center'}}>   
                <CircularProgress size={30} sx={{color: '#1a90ff', margin: '0px auto'}}/>
              </Container>
            : <></>}

            <Grid container spacing={1} mt={3} mb={3}>
              <Grid item xs={12}>
                <Typography variant="body2">
                  {t("Note")}
                </Typography>

                <Typography variant="body2" style={{fontSize: 12}}>
                  {t("System support only one pickup request per day")}
                </Typography>

                <Typography variant="body2" style={{fontSize: 12}}>
                  {t("pickupDateCannotBePast")}
                </Typography>

                <Typography variant="body2" style={{fontSize: 12}}>
                  {t("pickupDateShouldNotAfterSevenDay")}
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>          
        </Dialog>      
      );    
  } 
   
  return (
      <DashboardLayout>
        <DashboardNavbar pageTitle = {t('Pickup Requests')} />
        <MDBox my={3}>    


          <MDBox display="flex" justifyContent="flex-end" mb={2}>
              <MDBox ml={1}>
                <Button    
                    variant="contained" 
                    sx={{color : '#FFFFFF', height : 45, margin: '10px'}} 
                    disableRipple
                    onClick={() => handlePickupSubmit()}>
                    {t('New Pickup Request')}         
                </Button>               
              </MDBox>             
          </MDBox>

          {pickupModelOpen ? pickupModelLoad() : <></>}


          <Card>
            {tableData.columns && tableData.columns.length > 0 ?
              <DataTable 
                table={ tableData } 
                isSorted={ false }
                showTotalEntries={ true }
                responseResultCount={ resultCount }
                paginationSize = { paginationSize }
                paginationLink = {"/order/pickup/page-"}
                pageSelected = {pageSelected}
              />
            : <></>}
          </Card>
        </MDBox>
      </DashboardLayout>
  );
}

export default Pickup;